import React, { useState } from 'react'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import LgySelectField from 'app/components/util/lgy-select-field/LgySelectField'
import LgyInputField from '../../../../components/util/lgy-input-field/LgyInputField'
import LgyTextArea from '../../../../components/util/lgy-text-area/LgyTextArea'
import { LgySubsection } from '../../../../components/util/lgy-section/LgySection'
import { required, numeric, minValue } from 'app/utils/validations'
import { addFAQ, fetchFAQs, clearFAQMessages } from '../actions/faqActions'
import { deleteFAQCategory, fetchFAQCategories, clearFAQCategoryMessages } from '../actions/faqCategoryActions'

const minValue0 = minValue(0)
const DEFAULT_FAQ_CATEGORY = 'Miscellaneous'

const onSubmitAddQuestion = (formValues, dispatch, formProps) => {
  formProps.reset()
  formValues.category && dispatch(addFAQ(formValues.question, formValues.answer, formValues.sortOrder, formValues.category))
  renderUpdates(dispatch)
}

const renderUpdates = async (dispatch) => {
  await dispatch(clearFAQMessages())
  await dispatch(clearFAQCategoryMessages())
  await dispatch(fetchFAQs())
  await dispatch(fetchFAQCategories())
}

let AddQuestionForm = ({ categories, pristine, submitting, reset, handleSubmit, dispatch }) => {
  const [addingCategory, setAddingCategory] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState('')

  const deleteSelectedCategory = () => {
    selectedCategory && selectedCategory !== DEFAULT_FAQ_CATEGORY
      && dispatch(deleteFAQCategory(categories.find((cat) => cat.description === selectedCategory).id))
    renderUpdates(dispatch)
  }

  return (
    <LgySubsection header='Add a new frequently-asked question'>
      <form className='add-question-form' onSubmit={handleSubmit}>
        <Field
          name='question'
          type='text'
          component={LgyInputField}
          label='Question'
          maxLength='2000'
          validate={required}
          required
        />
        <Field
          name='answer'
          type='text'
          component={LgyTextArea}
          label='Answer'
          maxLength='2000'
          placeholder='Up to 2000 characters'
          validate={required}
          required
        />
        {(!addingCategory && categories
          && <Field
            component={LgySelectField}
            label='Category'
            name='category'
            required
            onChange={(e) => setSelectedCategory(e.target.value)}
            tooltip='Choose a category to associate with this question.'>
            {Object.values(categories).map(category =>
              <option key={category.id} value={category.description}>{category.description}</option>)}
          </Field>)}
        {addingCategory && <Field
          name='category'
          type='text'
          component={LgyInputField}
          label='New Category Name'
          validate={required}
          maxLength='50'
          aria-label='Up to 50 characters'
          placeholder='Up to 50 characters'
          tooltip='You can associate this question with a new category.'
          required
        />}
        <button type='button' onClick={() => { setAddingCategory(!addingCategory) }}>{addingCategory ? 'Select Existing Category' : 'Add New Category'}</button>
        {!addingCategory && <button type='button' onClick={deleteSelectedCategory}>{'Delete Category'}</button>}
        <Field
          name='sortOrder'
          type='text'
          component={LgyInputField}
          label='Sort Order'
          validate={[required, numeric, minValue0]}
          maxLength='2'
          placeholder='E.g. 1 or 5'
          required
        />

        <button type='submit' disabled={pristine || submitting}>{submitting ? 'Submitting...' : 'Submit'}</button>
        <button type='button' disabled={pristine || submitting} onClick={reset}>Reset</button>
      </form>
    </LgySubsection>)
}
const mapDispatchToProps = { deleteFAQCategory }

AddQuestionForm = reduxForm({
  form: 'addQuestionForm',
  onSubmit: onSubmitAddQuestion
})(AddQuestionForm)

AddQuestionForm = connect(null, mapDispatchToProps)(AddQuestionForm)

export default AddQuestionForm